import {LayersControl, TileLayer} from "react-leaflet";
import React, {useEffect, useRef} from "react";
import {useSearchParams} from "react-router-dom";

const tileProviders = {
    openstreetmap: {
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    },
    opentopomap: {
        url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
        attribution: 'Map data: &copy; <a href="https://www.opentopomap.org">OpenTopoMap</a> (CC-BY-SA)',
    },
    tracestrack: {
        url: 'https://tile.tracestrack.com/topo__/{z}/{x}/{y}.png?key=983f31169df214a6e3d13ae9307ae93e',
        attribution: 'Map data: &copy; <a href="https://www.tracestrack.com">TracesTrack</a> (CC-BY-SA)',
    }
};

function LayersControlWithClass({ children, className, position }) {
    const controlRef = useRef();

    useEffect(() => {
        if (!controlRef.current) return;
        const container = controlRef.current.getContainer();
        container.classList.add(className);
    }, [className]);

    return (
        <LayersControl ref={controlRef} position={position}>
            {children}
        </LayersControl>
    );
}


const TileLayersWithControl = () => {
    // Get the mapTiles params from the url
    const [searchParams] = useSearchParams();
    const mapTiles = searchParams.get("mapTiles") || "openstreetmap";

    return <LayersControlWithClass position="bottomleft" className="layers-control-tiles">
        {Object.keys(tileProviders).map((providerKey) => (
            <LayersControl.BaseLayer key={providerKey} name={providerKey} checked={mapTiles === providerKey}>
                <TileLayer url={tileProviders[providerKey].url} attribution={tileProviders[providerKey].attribution}/>
            </LayersControl.BaseLayer>
        ))}
    </LayersControlWithClass>
}

export default TileLayersWithControl;

